import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { Table } from 'ui/table/Table';

import { PassagesListProps } from './PassagesList.types';
import { PassagesTableHeader } from './passagesTableHeader/PassagesTableHeader';
import { PassagesTableRow } from './passagesTableRow/PassagesTableRow';

export const PASSAGES_COLUMNS = '146px 1.4fr 1fr 1.4fr 1.4fr 50px';

export const PassagesList = ({ passages, isLoading, isDeleteDisabled, deleteDisabledReason }: PassagesListProps) => {
  const { formatMessage } = useLocale();

  return (
    <Table
      gridTemplateColumns={PASSAGES_COLUMNS}
      data={passages}
      nothingToShowText={formatMessage({ id: AppMessages['definitions.passages.nothingToShow'] })}
      customTableHeight={() => undefined}
      isLoading={isLoading}
      renderHeader={() => <PassagesTableHeader />}
      renderRow={(passage) => (
        <PassagesTableRow
          passage={passage}
          isDeleteDisabled={isDeleteDisabled}
          deleteDisabledReason={deleteDisabledReason}
        />
      )}
    />
  );
};
